import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import * as url from "../../../helpers/url_helper";
import { Card, CardBody, Col, Row } from "reactstrap";
import Request from "../../../helpers/request";
import DataTable from "react-data-table-component";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";

function DateWiseStreak() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const today = new Date();
  const formattedEndDate = today.toISOString().split("T")[0];
  const start = new Date();
  start.setDate(today.getDate() - 10);
  const formattedStartDate = start.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState<string>(formattedStartDate);
  const [endDate, setEndDate] = useState<string>(formattedEndDate);

  const fetchData = async () => {
    setLoading(true);

    try {
      const reqObj = {
        mode: "DATE_WISE_STREAK_ANALYTICS",
        startDate,
        endDate,
      };

      const response = await Request.post(
        `${url.BASE_URL}${url.DATE_WISE_STREAK_URL}`,
        reqObj,
      );

      setData(response.data?.data || []);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  const StreakColumns = [
    {
      name: "Date",
      selector: (row: any) => row.date || "-",
      cell: (row: any) => <div>{row?.date || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },
    {
      name: "Total Users",
      selector: (row: any) => row.totalUserStreaks || "-",
      cell: (row: any) => <div>{row?.totalUserStreaks || "-"}</div>,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Top City",
      selector: (row: any) =>
        row?.topCity
          ? `${row.topCity.cityName} (${row.topCity.streakCount})`
          : "-",
      cell: (row: any) => (
        <div>
          {row?.topCity
            ? `${row.topCity.cityName} (${row.topCity.streakCount})`
            : "-"}
        </div>
      ),
      sortable: true,
      grow: 2,
      wrap: true,
    },
  ];

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col>
          <Card
            style={{
              marginTop: 100,
              marginLeft: 30,
              marginRight: 30,
              marginBottom: 0,
            }}
          >
            <CardBody>
              <Row>
                <Col>
                  <DataTable
                    columns={StreakColumns}
                    data={data}
                    customStyles={customStyles}
                    subHeader
                    subHeaderComponent={
                      <div className="container-fluid p-0 pb-2">
                        <div className="d-flex justify-content-end align-items-end gap-3">
                          <div className="d-flex justify-content-start align-items-start me-auto">
                            <h5 className="fw-bold ">
                              Date Wise Streak Analytics
                            </h5>
                          </div>

                          <div className="d-flex justify-content-end align-items-end gap-2">
                            <label className="d-flex w-100 align-items-center justify-content-center">
                              Start Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          {/* cityName */}

                          <div className="d-flex justify-content-end align-items-end gap-2">
                            <label className="d-flex w-100 justify-content-center align-items-center">
                              End Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    }
                  />
                </Col>
              </Row>
              {loading && <AirHomeLoader />}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default DateWiseStreak;

export const customStyles: any = {
  tableWrapper: {
    style: {
      minWidth: "1100px",
    },
  },
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};
